import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const NotesInputContainer = styled(Box)`
  background-color: ${colorPalette.yellow950};
  border: 1px solid ${colorTokens.border.main};
  border-radius: 12px;
  padding: 12px;
  padding-bottom: 0;
`;

export const NotesTitle = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  svg {
    margin-right: 6px;
  }
`;

export const NotesContent = styled.div`
  max-height: 100px;
  overflow-y: scroll;
  padding-bottom: 24px;
`;

export const Note = styled(Box)`
  margin-bottom: 12px;

  .author {
    display: flex;
    align-items: center;

    .name {
      margin-left: 9px;
    }
  }

  .timestamp,
  .content {
    margin-left: 42px;
  }

  .timestamp {
    display: flex;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }

    svg,
    p {
      color: ${colorTokens.text.secondary} !important;
    }
  }

  .content {
    font-size: 16px;
    font-weight: 400;
  }
`;

export const NotesFooter = styled(Box)`
  background-color: ${colorPalette.white};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 6px;
  margin: 0 -12px;

  button.add {
    width: 156px;
    color: ${colorTokens.text.contrast};

    svg {
      width: 16px;
      height: 16px;
    }

    svg,
    span {
      color: ${colorTokens.text.contrast} !important;
    }

    &.disabled {
      svg,
      span {
        color: ${colorTokens.text.secondary} !important;
      }
    }
  }
`;
